/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/lines-between-class-members */
/* eslint-disable class-methods-use-this */

import { Menu, MenuButton, MenuList } from '@chakra-ui/react';
import {
  Cell,
  CellTemplate,
  Compatible,
  Uncertain,
  getCellProperty,
  isAlphaNumericKey,
  isNavigationKey,
  keyCodes,
} from '@silevis/reactgrid';
import React, { useState } from 'react';
import { BiFilter } from 'react-icons/bi';

import { capitalizeFirstLetter } from 'utils/GlobalHelpers';

import MultiSelectTableFilters from './MultiSelectTableFilters';

export interface StableSelectCell extends Cell {
  type: 'select';
  text: string;
  rowId: string;
  property: string;
}

const FilterMenuButton = MenuButton as React.ElementType;
const FilterMenuList = MenuList as React.ElementType;

const CustomFilter = ({ cell }: any) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const reference = React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const label = capitalizeFirstLetter(cell?.text);

  return (
    <>
      <div
        ref={reference}
        style={{
          alignItems: 'center',
          display: 'flex',
          gap: 4,
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <p
          title={label}
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            flex: 1,
            minWidth: 0,
            textOverflow: 'ellipsis',
            paddingLeft: '3px',
          }}
        >
          {label}
        </p>
        <Menu
          variant={'filter'}
          strategy='fixed'
          isOpen={isMenuOpen}
          onClose={() => setIsMenuOpen(false)}
          onOpen={() => setIsMenuOpen(true)}
        >
          <FilterMenuButton
            aria-label={`Filter ${label}`}
            onCopy={(event: any) => event.stopPropagation()}
            onCut={(event: any) => event.stopPropagation()}
            onPaste={(event: any) => event.stopPropagation()}
            onPointerDown={(event: any) => event.stopPropagation()}
            onKeyDown={(event: any) => {
              if (isAlphaNumericKey(event.keyCode) || isNavigationKey(event.keyCode)) {
                event.stopPropagation();
              }
            }}
          >
            <BiFilter size={24} color={'rgb(190 218 218)'} />
          </FilterMenuButton>
          <FilterMenuList
            px={3}
            py={3}
            w='min(420px, 90vw)'
            maxW='90vw'
            ref={(input: HTMLElement | null) => {
              input && input.focus();
            }}
            onCopy={(event: any) => event.stopPropagation()}
            onCut={(event: any) => event.stopPropagation()}
            onPaste={(event: any) => event.stopPropagation()}
            onPointerDown={(event: any) => event.stopPropagation()}
            onKeyDown={(event: any) => {
              if (isAlphaNumericKey(event.keyCode) || isNavigationKey(event.keyCode)) {
                event.stopPropagation();
              }
            }}
          >
            <div
              style={{ width: '100%', overflowX: 'auto', paddingBottom: 0 }}
              className='sm-scroll'
            >
              <MultiSelectTableFilters dimensionId={cell?.id} setIsMenuOpen={setIsMenuOpen} />
            </div>
          </FilterMenuList>
        </Menu>
      </div>
    </>
  );
};

export class StableHeaderRow implements CellTemplate<Cell | StableSelectCell> {
  getCompatibleCell(uncertainCell: Uncertain<StableSelectCell>): Compatible<StableSelectCell> {
    const text = getCellProperty(uncertainCell, 'text', 'string');
    const value = Number.parseFloat(text);
    return { ...uncertainCell, text, value } as Compatible<StableSelectCell>;
  }

  handleKeyDown(
    cell: Compatible<StableSelectCell>,
    keyCode: number,
    ctrl: boolean,
    shift: boolean,
    alt: boolean,
  ): { cell: Compatible<StableSelectCell>; enableEditMode: boolean } {
    if (!ctrl && !alt && isAlphaNumericKey(keyCode)) return { cell, enableEditMode: true };
    return {
      cell,
      enableEditMode: keyCode === keyCodes.POINTER || keyCode === keyCodes.ENTER,
    };
  }
  getClassName(cell: any) {
    const isValid = cell.validator ? cell.validator(cell.text) : true;
    const className = cell.className ?? '';
    return `${isValid ? 'valid' : 'invalid'} ${
      cell.placeholder && cell.text === '' ? 'placeholder' : ''
    } ${className}`;
  }
  render(cell: Compatible<StableSelectCell>): JSX.Element {
    const label =
      cell?.text === 'start_value'
        ? 'Start Value'
        : cell?.text === 'growth_rate'
        ? 'Growth Rate'
        : capitalizeFirstLetter(cell?.text);

    return (
      <>
        {cell?.property === 'dimension' ? (
          <CustomFilter cell={cell} />
        ) : (
          <p
            title={label}
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              maxWidth: '100%',
              textOverflow: 'ellipsis',
              paddingLeft: '3px',
            }}
          >
            {label}
          </p>
        )}
      </>
    );
  }
}
